import React from 'react';
import { Text, Box } from '@wix/design-system';
import { PremiumSmall } from '@wix/wix-ui-icons-common/lazy';
import { useEssentials } from '../../contexts/essentials-context';

export interface PremiumSiteRequiredBadgeProps {
  size?: 'tiny' | 'small';
  showIcon?: boolean;
}

export function PremiumSiteRequiredBadge({
  size = 'tiny',
  showIcon = true,
}: PremiumSiteRequiredBadgeProps) {
  const { t } = useEssentials();

  return (
    <Box gap="2px" verticalAlign="middle">
      {showIcon && <PremiumSmall />}
      <Text size={size} weight="thin" skin="standard" secondary>
        {t('app.pricing.Premium')}
      </Text>
    </Box>
  );
}
